export default "<div fxLayout=\"row\" fxLayoutAlign=\"center center\" fxFlexFill>\n  <amplify-authenticator >\n  </amplify-authenticator>\n</div>\n";